<template>
  <div id="scroll-target">
    <vs-row class="mb-2">
      <vs-col vs-type="flex" vs-lg="7" vs-sm="12" class="m-0 p-0"> </vs-col>
      <vs-col vs-align="flex-end" vs-lg="5" vs-sm="12" class="m-0 p-0">
        <div class="text-right hidden lg:inline-block" style="float: right">
          <ul class="demo-alignment pb-0" style="float: right">
            <li class="pl-4 border-0 border-solid border-grey">
              <i
                class="fas fa-file-download fa-2x cursor-pointer hover:text-primary"
                @click="onExport()"
              ></i>
            </li>
          </ul>
        </div>
      </vs-col>
    </vs-row>
    <vs-card>
      <b-table
        ref="table"
        style="min-height: 600px;"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :foot-clone="true"
        no-footer-sorting
        :no-provider-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height:600px;">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(no)="data">
          <div>{{ data.value }}</div>
        </template>
        <template v-slot:cell(Total_number_of_delegates)="data">
          <div>{{ data.value | numFormat("0,0") }}</div>
        </template>
        <template v-slot:cell(Number_of_votes_cast_Submit)="data">
          <div>{{ data.value | numFormat("0,0") }}</div>
        </template>
        <template v-slot:cell(Number_of_votes_cast_Saved_in_draft)="data">
          <div>{{ data.value | numFormat("0,0") }}</div>
        </template>
        <template v-slot:cell(Number_of_Yes_votes)="data">
          <div>{{ data.value | numFormat("0,0") }}</div>
        </template>
        <template v-slot:cell(Percentage_of_Yes_votes)="data">
          <div>{{ data.value | numFormat("0,0") }}</div>
        </template>
        <template v-slot:cell(Number_of_No_votes)="data">
          <div>{{ data.value | numFormat("0,0") }}</div>
        </template>
        <template v-slot:cell(Percentage_of_No_votes)="data">
          <div>{{ data.value | numFormat("0,0") }}</div>
        </template>
        <!-- A custom formatted footer cell for field 'name' -->
        <!--
        <template #foot()="data">
          <div style="font-weight:bolder; font-size:1.1rem;">
            <b>{{ data.field.foot }}</b>
          </div>
        </template>
        -->
      </b-table>
      <!--
      <data-table :columns="columns" :data="data" @onTablePropsChanged="reloadTable"></data-table>
      -->
      <div v-if="showPagination" class="mt-3 text-right">
        <vs-pagination
          :total="Math.ceil(totalRows / 30)"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>

        <div class="mt-3">{{ from }} to {{ to }} of {{ totalRows }} orders</div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import Service from "@/services";
import XLSX from "xlsx"; // import xlsx
export default {
  components: {},
  data: () => ({
    order_id: null,
    isBusy: false,
    showPagination: false,
    currentPage: 1,
    perPage: 1000,
    totalRows: 0,
    selected: [],
    search: "",
    filter: "",
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    columns: [
      { label: "Position", key: "title", sortable: true, foot: "" },
      {
        label: "Total",
        key: "total",
        sortable: true,
        foot: ""
      }
    ],
    items: []
  }),
  watch: {},
  created() {
    this.order_id = this.$route.query.o;
  },
  methods: {
    debounceInput: _.debounce(function(e) {
      this.filter = e;
      this.search = e;
    }, 500),
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          form_id: 36,
          e: this.$route.query.e
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map(key => key + "=" + ctx[key])
            .join("&");

        return Service.Report.voteSummaryCandidate(params)
          .then(res => {
            this.data = res.data.map(item => {
              return {
                ...item
              };
            });

            let results = [];
            this.data.map(item => {
              let r = [];
              //r["title"] = item["no"];

              results.push({ title: item["no"], total: "" });
              if (item["Candidates"]) {
                results.push({
                  title: "Total number of voters",
                  total: item["Total_number_of_delegates"]
                });
                results.push({
                  title: "Number of votes cast",
                  total: item["Number_of_votes_cast"]
                });
                item["Candidates"].map((candidate, index) => {
                  results.push({
                    title: candidate.name,
                    total:
                      candidate.count +
                      " (" +
                      candidate.percentage.toFixed(2) +
                      "%)"
                  });
                });
              }
            });

            callback(results);
          })
          .catch(error => {
            callback([]);
          });
      }, 500);
    },
    onExport() {
      let rows = [];
      let days = [];

      let header = this.columns.map((item, index) => {
        return { text: item.label };
      });

      this.data.map(item => {
        let r = [];
        //r["title"] = item["no"];

        rows.push({ title: item["no"], total: "" });
        if (item["Candidates"]) {
          rows.push({
            title: "Total number of voters",
            total: item["Total_number_of_delegates"]
          });
          rows.push({
            title: "Number of votes cast",
            total: item["Number_of_votes_cast"]
          });
          item["Candidates"].map((candidate, index) => {
            rows.push({
              title: candidate.name,
              total:
                candidate.count + " (" + candidate.percentage.toFixed(2) + "%)"
            });
          });
        }
      });

      let dataExport = {};
      const dataWS = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "Candidate_Summary_report.xlsx");
      this.$vs.loading.close();
    }
  }
};
</script>
